/**
 * Created by reese on 2/28/17.
 */
import moment from 'moment-timezone';
import store from 'store';
import pick from 'lodash.pick';
import {saveAs} from 'file-saver';

/*global google*/
/*eslint no-undef: "error"*/

export default class PolyUtil {
    static consoleOnlyError(params) {
        if (params.callback) {
            params.callback();
        }
        // Error to console
        console.error(params.status, params.xhr.status, params.err.toString());
    }

    static JSONError(params) {
        let xhr = params.xhr
            , err = params.err
            , status = params.status
            , customError = params.customError
            , reactThis = params.reactThis
            , invalidateForm = params.invalidateForm;
        let response = {};
        try {
            response = JSON.parse(xhr.responseText);
        }
        catch (e) {
            console.error(e);
            /* couldn't parse, fall back to HTTP error or customError (if defined) */
        }

        // Add alert to UI
        if (response.error_message || customError) {
            reactThis.setState({error: customError ? customError : response.error_message});
            delete response.error_message;
            delete response.error_code;
        }
        else if (response.non_field_errors) {
            reactThis.setState({error: response.non_field_errors[0]});
            delete response.non_field_errors;
        }
        // Invalidate form (if needed)
        else if (invalidateForm && Object.keys(response).length > 0) {
            try {
                invalidateForm(response);
            } catch (e) {
                console.error(e);
            }
        }
        else {
            let error = err.toString() + ' (HTTP ' + xhr.status + ')';
            reactThis.setState({error: error});
        }

        if (params.callback) {
            params.callback();
        }
        // Error to console
        console.error(status, xhr.status, err.toString());
    }

    static formatPhone(phone) {
        let sPhone = phone ? phone.substring(2) : '';
        return (
            sPhone.slice(0, 3) + '-' + sPhone.slice(3, 6) + '-' + sPhone.slice(6)
        );
    }

    static formatDate(date) {
        if (!date) return null;

        return (
            moment(date, moment.ISO_8601).format('MM/DD/YYYY')
        );
    }

    static formatDatetime(date) {
        return (
            moment(date, moment.ISO_8601).tz('America/Los_Angeles').format('MM/DD/YYYY h:ma z')
        );
    }

    static formatAPIDate(date) {
        return (
            !!date ? moment(date).format("YYYY-MM-DD") : null
        );
    }

    static formatUSD(value) {
        if (!value)
            return null;
        return '$' + parseFloat(value.toString().replace(/[^0-9.]/g,'')).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    }

    static formatTitleCase(str) {
        if (!str)
            return null;
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }

    static formatCommas(str) {
        if (!str)
            return null;
        return str.split(',').join(', ');
    }

    static validArr(arr) {
        return !!arr && Array.isArray(arr) && arr.length > 0;
    }

    static objEmpty(obj) {
        return Object.keys(obj).length === 0;
    }

    static nvl(value1, value2) {
        if (value1 === null || value1 === undefined)
            return value2;
        return value1;
    }

    static nvlz(value1, value2) {
        if (value1 === null || value1 === undefined || value1 === 0)
            return value2;
        return value1;
    }

    static buildStreetViewUrl(sizeX, sizeY, address) {
        let url = 'https://maps.googleapis.com/maps/api/streetview?';
        url += 'size=' + sizeX + 'x' + sizeY;
        url += '&location=' + address;
        url += '&pitch=-0.76';
        url += '&key=' + process.env.REACT_APP_POLYRENTS_GOOGLE_API_KEY;

        return url;
    }

    static geocodePlace(place_id) {
        let geocoder = new google.maps.Geocoder();
        return new Promise(function (resolve, reject) {
            geocoder.geocode({'placeId': place_id}, function (results, status) {
                if (status === 'OK') {
                    if (results[0]) {
                        const address = PolyUtil.addressComponentsReader(results[0].address_components);
                        resolve(address);
                    } else {
                        reject('No results in Google Maps found for the address specified');
                        console.error('No results found for place_id given by API');
                    }
                }
                else {
                    reject('Geocoder failed due to: ' + status);
                    console.error('Geocoder failed due to: ' + status);
                }
            });
        });
    }

    static addressComponentsReader(address_components) {
        if (!address_components) return {
            formatted_address: null,
            street_address: null,
            city: null,
            state: null,
            zipcode: null
        };

        let address = {}, street_number, street;
        address_components.forEach(function (address_component) {
            switch (address_component.types[0]) {
                case 'street_number':
                    street_number = address_component.short_name;
                    break;
                case 'route':
                    street = address_component.short_name;
                    break;
                case 'postal_code':
                    address.zipcode = address_component.short_name;
                    break;
                case 'administrative_area_level_1':
                    address.state = address_component.short_name;
                    break;
                case 'locality':
                    address.city = address_component.short_name;
                    break;
                default:
                    break;
            }
        });
        address.street_address = (street_number ? (street_number + ' ') : '') + (street ? street : '');
        address.formatted_address = address.street_address + " " + address.city + ", " + address.state + " " + address.zipcode;
        return address;
    }

    static getPropertyAddress(property) {
        return PolyUtil.addressComponentsReader(property.address_details.address_components);
    }

    static getPropertyStreetAddress(property) {
        return PolyUtil.getPropertyAddress(property).street_address;
    }

    static getPropertyCity(property) {
        return PolyUtil.getPropertyAddress(property).city;
    }

    static getPropertyState(property) {
        return PolyUtil.getPropertyAddress(property).state;
    }

    static getPropertyZip(property) {
        return PolyUtil.getPropertyAddress(property).zipcode;
    }

    static getPropertyAddressString(property) {
        const address = PolyUtil.getPropertyAddress(property);

        return address.street_address + ", " + address.city + ", " + address.state;
    }

    static formatPhoneStd(val) {
        return '+1' + val.replace(new RegExp('-', 'g'), '');
    }

    static getPropertyAddressStringFull(property) {
        const address = PolyUtil.getPropertyAddress(property);

        return address.street_address + ", " + address.city + ", " + address.state + ", United States";
    }

    static validStreetAddress(result) {
        return result.types[0] === "street_address" ||
            result.types[0] === "premise" ||
            result.types[0] === "subpremise";
    }

    static addressFormatTU(data) {
        let out = {};
        out.address_line_1 = data.street_address;
        out.address_line_2 = data.identifier;
        out.city = data.city;
        out.state = data.state;
        out.zip_code = data.zipcode;
        return out;
    }

    static colorCalc(value, max) {
        const perc = (value / max) * 100;

        if (perc < 25) return 'danger';
        else if (perc < 70) return 'warning';
        else return 'success';
    }

    static childrenNull(object) {
        if (!object) return true;

        for (let property in object) {
            if (object.hasOwnProperty(property)) {
                if (object[property]) return false;
            }
        }

        return true;
    }

    static guid() {
        let text = "";
        const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

        for (let i = 0; i < 5; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    }

    static createPDFName(names) {
        return "Application_" + names.join('_');
    }

    static isMobile() {
        return ( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 768);
    }

    static propsReady(props, required) {
        for (let prop in !!required ? pick(props, required) : props) {
            if (props.hasOwnProperty(prop)) {
                if (!prop) return false;
            }
        }

        return true;
    }

    static polyRender(props, required, content, alt) {
        if (PolyUtil.propsReady(props, required)) return content();
        else return alt;
    }

    /*
        Function that parses through form JSON data and converts necessary fields to API-friendly formats

        - Recursively handles nested objects within form fields
        - Can handle arrays of fields or objects from form data
        - Formats moment dates to YYYY-MM-DD
        - Formats phone numbers to +1##########
        - Capitalizes first letters of names

        Returns a copy of provided object so that form fields are not mutated
     */
    static prepData(obj) {
        if (obj === null) {
            return null;
        }

        const preppedObj = Object.assign({}, obj);

        const names = Object.getOwnPropertyNames(obj);
        for (let i = 0; i < names.length; i++) {
            if (obj.hasOwnProperty(names[i])) {
                const property = names[i].toString();
                const value = obj[property];

                if (value === null) {
                    preppedObj[property] = null;
                } else if (Array.isArray(value)) {                                                 // Check if prop is array & iterate
                    preppedObj[property] = value.map((entry) => {
                        return PolyUtil.prepData(entry);
                    });
                } else if (value === Object(value) && !(value instanceof moment)) {         // Call prepData recursively if prop is object
                    preppedObj[property] = PolyUtil.prepData(value);
                } else if (!!value.format) { // Check if value is a moment date (has format function in _proto_)
                    preppedObj[property] = obj[property].format('YYYY-MM-DD');              // Format date
                } else if (property.toLowerCase().includes('phone')) {
                    preppedObj[property] = PolyUtil.formatPhoneStd(value);                  // Format phone
                } else if (property.toLowerCase().includes('name')) {
                    preppedObj[property] = PolyUtil.formatTitleCase(value); // Capitalize names
                }
            }

        }

        return preppedObj;
    }

    /*
     Wrapper which configures fetch() with common settings for PolyRents project

     - Parses JSON from response and returns
     - Rejects the Promise if server returned HTTP error (e.g. 403 or 500), use .catch() to handle such errors
     - Sets base url to PolyRents API, mode to cross-origin, content-type to json, and attaches token for authentication

     Usage:

     PolyUtil.fetchWrapper(url, {method: ['GET'/'POST'/etc.], [body: ]})
     .then((responseJSON) => {})
     .catch((errorJSON) = > {})

     */
    static fetchWrapper(url, params) {
        return fetch(
            process.env.REACT_APP_POLYRENTS_API_BASE_URL + url, // Add PolyRents API address to URL
            {
                headers: {'Content-Type': 'application/json', 'Authorization': store.get('access_token')},
                mode: 'cors', ...params
            }) // combine default and user-defined params
            .then(response => { // parse JSON
                return response.json().then(json => {
                    return response.ok ? json : Promise.reject(json); // trigger failure on HTTP error
                });
            });
    }

    static fetchPDF(url, params, saveName) {
        return fetch(
            process.env.REACT_APP_POLYRENTS_API_BASE_URL + url, // Add PolyRents API address to URL
            {
                headers: {'Content-Type': 'application/pdf', 'Authorization': store.get('access_token')},
                responseType: 'blob',
                ...params
            }
        ).then(response => {
            return response.blob();
        }).then(blob => saveAs(blob, saveName));
    }

    static fetchNoResponse(url, params) {
        return fetch(
            process.env.REACT_APP_POLYRENTS_API_BASE_URL + url, // Add PolyRents API address to URL
            {
                headers: {'Content-Type': 'application/json', 'Authorization': store.get('access_token')},
                mode: 'cors', ...params
            });
    }
}



// WEBPACK FOOTER //
// ./src/util/PolyUtil.js